import { Lookup } from "@data-types";
import { CountryQuery } from "@data-types/country/CountryQuery";
import { CountryDataType } from "@data-types/membership/registration";
import { httpClient, retryRequest } from "@utils";
import { getApiRequestContext } from "@utils/api-config";
import { getApplicationRequestHeaders } from "@utils/api-config/getApplicationRequestHeader";
import { ApiRequestContextData } from "@utils/api-config/types";

class PlatformCountryApiService {
	static get baseUrl() {
		return `${WEBPACK_BASE_ADDRESS}platform/countries`;
	}

	static getRequestHeaders = (
		options: ApiRequestContextData = getApiRequestContext()
	) => {
		const appHeaders = getApplicationRequestHeaders(options);
		appHeaders["Content-Type" as keyof HeadersInit] = "application/json";
		return appHeaders;
	};

	static async findCountries(
		query: CountryQuery = CountryQuery.DEFAULT
	): Promise<Lookup<CountryDataType>> {
		const response = await retryRequest(() =>
			httpClient.get(`${this.baseUrl}${query}`, this.getRequestHeaders())
		);

		return response;
	}
}

export default PlatformCountryApiService;
